var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2261 3.25H8.22607C5.05607 3.25 2.47607 5.83 2.47607 9V15C2.47607 18.17 5.05607 20.75 8.22607 20.75H16.2261C19.3961 20.75 21.9761 18.17 21.9761 15V9C21.9761 5.83 19.3961 3.25 16.2261 3.25ZM20.4761 15C20.4761 17.34 18.5661 19.25 16.2261 19.25H8.22607C5.88607 19.25 3.97607 17.34 3.97607 15V9C3.97607 6.66 5.88607 4.75 8.22607 4.75H16.2261C18.5661 4.75 20.4761 6.66 20.4761 9V15Z",
    fill: "var(--color-color7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2261 13.25H9.22607C8.53607 13.25 7.97607 12.69 7.97607 12C7.97607 11.31 8.53607 10.75 9.22607 10.75H10.2261C10.6361 10.75 10.9761 10.41 10.9761 10C10.9761 9.59 10.6361 9.25 10.2261 9.25H9.22607C7.70607 9.25 6.47607 10.48 6.47607 12C6.47607 13.52 7.70607 14.75 9.22607 14.75H10.2261C10.6361 14.75 10.9761 14.41 10.9761 14C10.9761 13.59 10.6361 13.25 10.2261 13.25Z",
    fill: "var(--color-color7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2261 9.25H14.2261C13.8161 9.25 13.4761 9.59 13.4761 10C13.4761 10.41 13.8161 10.75 14.2261 10.75H15.2261C15.9161 10.75 16.4761 11.31 16.4761 12C16.4761 12.69 15.9161 13.25 15.2261 13.25H14.2261C13.8161 13.25 13.4761 13.59 13.4761 14C13.4761 14.41 13.8161 14.75 14.2261 14.75H15.2261C16.7461 14.75 17.9761 13.52 17.9761 12C17.9761 10.48 16.7461 9.25 15.2261 9.25Z",
    fill: "var(--color-color7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47607 12C9.47607 12.41 9.81607 12.75 10.2261 12.75H14.2261C14.6361 12.75 14.9761 12.41 14.9761 12C14.9761 11.59 14.6361 11.25 14.2261 11.25H10.2261C9.81607 11.25 9.47607 11.59 9.47607 12Z",
    fill: "var(--color-color7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocket);
export default __webpack_public_path__ + "static/media/socket.9c254caa277b3c0aed46594be0b42688.svg";
export { ForwardRef as ReactComponent };